export const SET_KBA_FORM_FIELDS = {
  firstPassword: 'first_password',
  confirmPassword: 'confirm_password'
};

export const KBA_PASSWORD_LENGTH = {
  MIN: 8,
  MAX: 36
};

export const MINIMUM_PASSED_VALIDATIONS_NUMBER = 3;
